import type { TFunction } from "i18next";
import { EnumDisabledReason, EnumPaymentMethodState } from "@/api/cashier";

type PaymentMethodStatusLike = {
  status?: EnumPaymentMethodState;
  disabled_reason?: EnumDisabledReason;
};

export const isPaymentMethodOffline = (
  item?: PaymentMethodStatusLike
): boolean =>
  item?.status === EnumPaymentMethodState.EnumPaymentMethodStateOffline ||
  item?.status === EnumPaymentMethodState.EnumPaymentMethodStateInactive;

export const isExchangeRateTechnicalIssue = (
  item?: PaymentMethodStatusLike
): boolean =>
  item?.disabled_reason ===
    EnumDisabledReason.EnumDisabledReasonTechnicalIssue ||
  item?.disabled_reason === EnumDisabledReason.EnumDisabledReasonDowntime;

export const getDisabledReasonTooltip = (
  t: TFunction,
  disabledReason?: EnumDisabledReason
): string | undefined => {
  switch (disabledReason) {
    case EnumDisabledReason.EnumDisabledReasonTempAccount:
      return t("deposit.methods.disabled_reason.temp_account");
    case EnumDisabledReason.EnumDisabledReasonDowntime:
    case EnumDisabledReason.EnumDisabledReasonManual:
    case EnumDisabledReason.EnumDisabledReasonTechnicalIssue:
      return t("deposit.methods.disabled_reason.downtime");
    default:
      return undefined;
  }
};
